
if (!navigator.userAgent.match(/BlackBerry|BB|PlayBook/i)) {
  window.addEventListener('scroll', throttle(parallax, 14));
  
  const scaleBg = window.innerWidth >= 1300
  
  function throttle(fn, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  };
  
  function parallax() {
    let scrolled = window.pageYOffset;
  
    const parallax = document.querySelectorAll('.parallax');
    const parallaxImage = document.querySelectorAll('.parallax-image');
  
    parallax.forEach(el => {
      let content = el.querySelector('.container');
      let offset = el.offsetTop
      let scrolledOffset = scrolled - offset
  
      if (scrolledOffset > 0) {
        let trans = `${(scrolledOffset * 0.25)}px`
        let sc = `${(100 + (scrolledOffset * .005))}%`
        let op = (1.5 - scrolledOffset * 0.0025);
        
        el.style.transform = `translateY(${trans})`
        scaleBg ? el.style.backgroundSize = sc : el.style.backgroundSize = 'cover'
        content.style.opacity = op;
      
      } else {
        el.style.transform = 'translateY(0)'
        scaleBg ? el.style.backgroundSize = '100%' : el.style.backgroundSize = 'cover'
        content.style.opacity = 1;
      }
    })
  
    parallaxImage.forEach(el => {
      let img = el.querySelector('img')
      let offset = el.offsetTop
      let scrolledOffset = scrolled - offset
      let sc = `${scrolledOffset * 0.0001 + 1}`
  
      img.style.transform = `scale(${sc})`
    })
  };
}